/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable max-len */
import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import Market, { Categories as MarketCategories, Statuses as MarketStatuses, ConnectionStatuses } from 'models/business/Market';
import ContentTypography from 'components/Common/ContentTypography';
import HeaderTypography from 'components/Common/HeaderTypography';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIconPopover from 'components/Common/ErrorIconPopover';
import pchomeLogo from 'assets/pchome-logo.png';
import shopeeLogo from 'assets/shopeeLoge.png';
import facebookLogo from 'assets/facebookLogo.png';
import SettingButton from './SettingButton';
import Styles from './index.module.css';

const fanPageStatusMsg = {
  [MarketStatuses.Confirmed]: '已授權',
  [MarketStatuses.Unconfirmed]: '未授權',
};

function MarketCard({
  market,
  updateOnClick,
  deleteOnClick,
  confirmFanPageOnclick,
}) {
  const [confirmedTextColor, setConfirmedTextColor] = useState('green');
  const renderConfirmedPopUp = useMemo(() => (
    <ErrorIconPopover>
      <div
        className={Styles.popoverContainer}
      >
        <div>
          <div
            className={Styles.popoverTitle}
          >
            開啟Facebook粉絲團授權
          </div>
        </div>
        <div className={Styles.popoverButtonContainer}>
          <div style={{ paddingRight: '12px' }}>
            <button
              type="button"
              className={Styles.popoverButton}
            >
              <a className={Styles.popoverLink} target="_blank" href="https://www.hhgalaxy.com.tw/qa/87#4" rel="noopener noreferrer" />
              如何開啟
            </button>
          </div>
          <div>
            <button
              type="button"
              className={Styles.popoverButton}
              onClick={confirmFanPageOnclick}
            >
              我已開啟!
            </button>
          </div>
        </div>
      </div>
    </ErrorIconPopover>
  ));

  useEffect(() => {
    if (market.fanPageStatus === MarketStatuses.Confirmed) setConfirmedTextColor('#0CB381');
    else setConfirmedTextColor('#F28379');
  }, [market]);

  return (
    <div
      className={Styles.container}
    >
      <div
        className={Styles.titleRow}
      >
        <div
          className={Styles.name}
        >
          <HeaderTypography>
            {market.name}
            {/* {` (${market.connected ? '串接完成' : '串接中'})`} */}
            {/* {` (${[ConnectionStatuses.Pending, ConnectionStatuses.Unconnected].includes(market.status) ? ConnectionStatuses.Pending : ConnectionStatuses.Connected})`} */}
            {` (${market.status === ConnectionStatuses.Connected ? ConnectionStatuses.Connected : ConnectionStatuses.Pending})`}
          </HeaderTypography>
        </div>
        <div
          className={Styles.checkIcon}
        >
          {market.fanPageStatus === MarketStatuses.Confirmed && <CheckCircleIcon />}
        </div>
        <div
          className={Styles.settingIcon}
        >
          <SettingButton
            updateOnClick={() => updateOnClick(market)}
            deleteOnClick={() => deleteOnClick(market)}
          />
        </div>
      </div>
      <div
        className={Styles.id}
      >
        {market.category === MarketCategories.Shopee ? market.serial : ''}
      </div>
      <div
        className={Styles.typeRow}
      >
        <div
          style={{
            paddingRight: '25px',
          }}
        >
          <ContentTypography>
            平台類型:
          </ContentTypography>
          <img src={market.category === MarketCategories.Shopee ? shopeeLogo : pchomeLogo} alt="market type logo" />
        </div>
        <div>
          <ContentTypography>
            粉絲團狀態:
          </ContentTypography>
          <img src={facebookLogo} alt="facebook circle" />
        </div>
        <div
          style={{
            paddingLeft: '5px',
            textAlign: 'left',
            font: 'normal normal bold 15px/21px Noto Sans TC',
            letterSpacing: '0px',
            color: confirmedTextColor,
          }}
        >
          {fanPageStatusMsg[market.fanPageStatus]}
        </div>
        {market.fanPageStatus === MarketStatuses.Unconfirmed && renderConfirmedPopUp}
      </div>
    </div>
  );
}

MarketCard.propTypes = {
  market: PropTypes.instanceOf(Market),
  updateOnClick: PropTypes.func,
  deleteOnClick: PropTypes.func,
  confirmFanPageOnclick: PropTypes.func,
};

MarketCard.defaultProps = {
  market: new Market(),
  updateOnClick: () => {},
  deleteOnClick: () => {},
  confirmFanPageOnclick: () => {},
};

export default MarketCard;
